(function() {
                        var src = "";
                        if (document.currentScript && document.currentScript.src) {
                            src = document.currentScript.src;
                        } else {
                            var scripts = document.getElementsByTagName("script");
                            if (scripts.length) src = scripts[scripts.length - 1].src || "";
                        }
                        if (!src) return;
                        var url = new URL(src, document.baseURI);
                        var p = url.pathname || "";
                        var base = "/";
                        var hashDirMatch = p.match(/^(.*?\/)[A-Za-z0-9_-]{8,64}\/(?:scripts|styles)\//);
                        if (hashDirMatch) {
                            base = hashDirMatch[1];
                        } else {
                            var i = p.indexOf("/scripts/");
                            if (i === -1) i = p.indexOf("/styles/");
                            if (i !== -1) base = p.slice(0, i + 1);
                        }
                        url.pathname = base;
                        url.search = "";
                        url.hash = "";
                        __webpack_require__.p = url.toString();
                    })();